import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const DetailsPage = () => {

    const { id } = useParams();
    const [product, setProduct] = useState(null);

    useEffect(() => {
        axios.get(`https://purvi-backend.onrender.com/product/${id}`)
            .then(res => setProduct(res.data))
            .catch(err => console.log(err));
    }, [id]);

    if (!product) return <h2>Loading...</h2>;

    return (
        <div style={{ padding: "40px" }}>

            <h1>{product.title}</h1>

            <img
                src={product.url}
                alt={product.title}
                style={{ width: "300px",height: "500px" }}
            />

            <h2 style={{ color: "green" }}>
                ₹{product.price}
            </h2>

            <p>{product.description}</p>

        </div>
    );
};

export default DetailsPage;